import Button from '../../../../components/buttons/Button';
import { useState } from 'react';
import classNames from 'classnames';
import styles from '../../../calendar/dev/shift-detail/Modal.module.css';
import { Form, FormState } from 'informed';
import Modal from 'react-modal';
import TyInput from '../../../../components/inputs/TyInput';
import Spinner from '../../../../components/Spinner';

interface ChangeIdPpvProps {
  onSubmit: (values: StateModalData) => Promise<void>;
  children?: React.ReactNode;
}

interface StateModalData {
  idPpv: string;
}

const ChangeIdPpv = ({ onSubmit, children }: ChangeIdPpvProps) => {
  const [openModal, setOpenModal] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (values: StateModalData)=> {
    setBusy(true);
    await onSubmit(values);
    setBusy(false);
  }

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Button
        onClick={(e) => {
          setOpenModal(true);
        }}
        className="enabled:hover:bg-secondary-400 enabled:hover:text-bg bg-secondary-100 min-w-fit disabled:cursor-not-allowed disabled:opacity-70"
      >
        {busy ? <Spinner show className="w-3" /> : children}
      </Button>
      <Modal
        isOpen={openModal}
        onRequestClose={() => setOpenModal(false)}
        shouldCloseOnOverlayClick
        className={classNames('bg-bg m-auto rounded-xl px-6 py-4 w-[1000px]')}
        overlayClassName={styles.overlay}
        ariaHideApp={false}
      >
        <Form
          onSubmit={(values: FormState<StateModalData>) => {
            submit(values.values);
            setOpenModal(false);
          }}
        >
          <TyInput name="idPpv" label="ID PPV" className="w-full" />
          <div className="flex justify-end items-center mt-8 gap-2">
            <Button
              type="button"
              className="w-12 flex justify-center hover:bg-error-300"
              onClick={() => setOpenModal(false)}
            >
              Zavřít
            </Button>
            <Button
              type="submit"
              className="w-12 flex justify-center enabled:hover:bg-primary-300 disabled:cursor-not-allowed"
            >
              Uložit
            </Button>
          </div>
        </Form>
      </Modal>
    </div>
  );
};

export default ChangeIdPpv;
